export default "__VITE_ASSET__DA7SyKaf__"